import api from "./client";

export async function listProductionOrders(params = {}) {
  const res = await api.get("/production-orders", { params });
  return res.data.data;
}

export async function deleteProductionOrders(ids) {
  const res = await api.delete("/production-orders/bulk", { data: { ids } });
  return res.data.data;
}

export async function createProductionOrder(payload) {
  const res = await api.post("/production-orders", payload);
  return res.data.data;
}

export async function updateProductionOrder(id, payload) {
  const res = await api.put(`/production-orders/${id}`, payload);
  return res.data.data;
}

export async function setProductionOrderKnife(id, knifeId) {
  const res = await api.put(`/production-orders/${id}/knife`, { knife_id: knifeId });
  return res.data.data;
}

// Operator
export async function listAssignedProductionOrders() {
  const res = await api.get("/production-orders/assigned");
  return res.data.data.items;
}

export async function getProductionOrder(id) {
  const res = await api.get(`/production-orders/${id}`);
  return res.data.data;
}

export async function createProductionOrderReport(id, payload) {
  const res = await api.post(`/production-orders/${id}/report`, payload);
  return res.data.data; // { id }
}

export async function createProductionOrderOperationReport(id, payload) {
  const res = await api.post(`/production-orders/${id}/operation-report`, payload);
  return res.data.data; // { id }
}

export async function completeProductionOrder(id) {
  const res = await api.post(`/production-orders/${id}/complete`);
  return res.data.data;
}

export async function startProductionOrderOperation(productionOrderId, routingOperationId) {
  const res = await api.post(
    `/production-orders/${productionOrderId}/operations/${routingOperationId}/start`
  );
  return res.data.data;
}

export async function finishProductionOrderOperation(productionOrderId, routingOperationId, payload) {
  const res = await api.post(
    `/production-orders/${productionOrderId}/operations/${routingOperationId}/finish`,
    payload
  );
  return res.data.data;
}

// Admin
export async function getProductionOrderOperationRequirements(productionOrderId, routingOperationId, qty) {
  const res = await api.get(
    `/production-orders/${productionOrderId}/operations/${routingOperationId}/requirements`,
    { params: { qty } }
  );
  return res.data.data; // { requirements, available_lots }
}

export async function getProductionOrderMaterialRequirements(productionOrderId) {
  const res = await api.get(`/production-orders/${productionOrderId}/material-requirements`);
  return res.data.data;
}

export async function completeProductionOrderOperation(productionOrderId, routingOperationId, fireReason) {
  const res = await api.post(
    `/production-orders/${productionOrderId}/operations/${routingOperationId}/complete`,
    fireReason ? { fire_reason: fireReason } : {}
  );
  return res.data.data;
}

export async function approveProductionOrderOperation(productionOrderId, routingOperationId, payload) {
  const res = await api.post(
    `/production-orders/${productionOrderId}/operations/${routingOperationId}/approve`,
    payload
  );
  return res.data.data; // { ok, approval_id, output_lot_no, operation }
}

export async function startApprovalSession(productionOrderId, routingOperationId) {
  const res = await api.post(
    `/production-orders/${productionOrderId}/operations/${routingOperationId}/start-approval`
  );
  return res.data.data; // { ok, approval_id, started_at }
}

export async function setProductionOrderProblem(id, payload) {
  const res = await api.post(`/production-orders/${id}/problem`, payload);
  return res.data.data; // { ok: true }
}

export async function syncProductionOrderOperations(id) {
  const res = await api.post(`/production-orders/${id}/sync-operations`);
  return res.data.data; // { ok, inserted, updated, deleted, ... }
}

export async function shipProductionOrder(id, koli, images = []) {
  const res = await api.post(`/production-orders/${id}/ship`, { koli: Number(koli), images });
  return res.data.data;
}
